"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LftIconBase_1 = __importDefault(require("../LftIconBase"));
var LftIconButton_1 = __importDefault(require("../LftIconButton"));
var LftInputBase_1 = __importDefault(require("../LftInputBase"));
var x_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/x"));
var loader_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/loader"));
var search_1 = __importDefault(require("@lift/assets/dist/assets/globals/icons/search"));
var S = __importStar(require("./LftInputSearch.styles"));
var LftInputSearch = (0, react_1.forwardRef)(function (_a, ref) {
    var autoComplete = _a.autoComplete, bgColor = _a.bgColor, _b = _a.cleanOnSubmit, cleanOnSubmit = _b === void 0 ? true : _b, dataElement = _a.dataElement, dataInfo = _a.dataInfo, dataTestId = _a.dataTestId, disabled = _a.disabled, _c = _a.id, id = _c === void 0 ? 'inputsearch' : _c, loading = _a.loading, _d = _a.maxLength, maxLength = _d === void 0 ? 100 : _d, _e = _a.name, name = _e === void 0 ? 'inputsearch' : _e, placeholder = _a.placeholder, _f = _a.required, required = _f === void 0 ? false : _f, _g = _a.tabIndex, tabIndex = _g === void 0 ? 0 : _g, _h = _a.value, value = _h === void 0 ? '' : _h, lftBlur = _a.lftBlur, lftChange = _a.lftChange, lftClick = _a.lftClick, lftClickInput = _a.lftClickInput, lftClickReset = _a.lftClickReset, lftClickSubmit = _a.lftClickSubmit, lftFocus = _a.lftFocus;
    var _j = (0, react_1.useState)(value), localValue = _j[0], setLocalValue = _j[1];
    var inputRef = (0, react_1.useRef)(null);
    var onChange = function (e) {
        var newValue = e ? e.currentTarget.value : '';
        setLocalValue(newValue);
        !!lftChange && lftChange(newValue);
    };
    var handleKeyDown = function (e) {
        if (e.key === 'Enter') {
            cleanOnSubmit && setLocalValue('');
            !!lftClickSubmit && lftClickSubmit(e);
        }
    };
    var _handleClear = function (e) {
        var _a;
        setLocalValue('');
        onChange(null);
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        !!lftClick && lftClick(e);
        !!lftClickReset && lftClickReset(e);
    };
    if (lftClick) {
        console.warn('@deprecated - devido a necessidade do LftInputSearch ter mais de um evento de click, renomeamos o LftClick para LftClickReset.');
    }
    (0, react_1.useEffect)(function () {
        setLocalValue(value);
    }, [value]);
    (0, react_1.useEffect)(function () {
        if (typeof ref === 'function') {
            ref(inputRef.current);
        }
        else if (ref) {
            ref.current = inputRef.current;
        }
    }, [ref]);
    return ((0, jsx_runtime_1.jsxs)(S.Wrapper, __assign({ "aria-disabled": disabled, bgColor: bgColor, "data-lift": "lft-input", disabled: disabled || loading, onKeyDown: handleKeyDown }, { children: [(0, jsx_runtime_1.jsx)(LftIconBase_1.default, { bgColor: bgColor, icon: search_1.default, size: 'md' }), (0, jsx_runtime_1.jsx)(LftInputBase_1.default, { ref: inputRef, autoComplete: autoComplete, dataElement: dataElement, dataInfo: dataInfo, dataLift: "search", dataTestId: dataTestId, disabled: disabled, id: id, maxLength: maxLength, name: name, placeholder: placeholder, required: required, tabIndex: tabIndex, type: "search", value: localValue, lftClick: lftClickInput, lftBlur: lftBlur, lftFocus: lftFocus, lftChange: onChange }), localValue && !loading &&
                (0, jsx_runtime_1.jsx)(LftIconButton_1.default, { bgColor: bgColor, disabled: disabled, icon: x_1.default, size: 'lg', lftClick: _handleClear }), loading &&
                (0, jsx_runtime_1.jsx)(LftIconBase_1.default, { className: "lft-search-loading", bgColor: bgColor, icon: loader_1.default, size: 'md' })] })));
});
exports.default = LftInputSearch;
